import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  'userDefinedRole.form.description': {
    defaultMessage: 'Description',
    id: 'userDefinedRole.form.description'
  },
  'userDefinedRole.form.heading': {
    defaultMessage: 'User-Defined Role',
    id: 'userDefinedRole.form.heading'
  },
  'userDefinedRole.form.name': {
    defaultMessage: 'Name',
    id: 'userDefinedRole.form.name'
  }
});
